module.exports = __webpack_public_path__ + "static/img/2-1-1-img-m.c4fdfbb.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/2/2-1-1-img-m.jpg
// module id = C9a4
// module chunks = 1